import { Flex, Tooltip } from "@p0security/ui";
import React from "react";
import { colors } from "styles/variables";

export const IconWithBadge: React.FC<{
  icon: React.ReactNode;
  badge?: React.ReactNode;
  tooltip?: string;
}> = ({ icon, badge, tooltip }) => (
  <Flex className="relative shrink-0">
    <Tooltip title={tooltip}>
      <Flex
        align="center"
        justify="center"
        className="h-8 w-8 rounded text-base"
        /* eslint-disable-line react/forbid-component-props */ style={{
          backgroundColor: colors.neutral["10"],
          color: colors.neutral["50"],
        }}
      >
        {icon}
      </Flex>
    </Tooltip>
    {badge && (
      <Flex className="absolute -bottom-1 -right-1 leading-none">{badge}</Flex>
    )}
  </Flex>
);
